/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductSortimentsPricingRequest } from '../../models/product-sortiments-pricing-request';
import { ProductSortimentsPricingResponse } from '../../models/product-sortiments-pricing-response';

export interface GetProductSortimentsForPricing$Params {
      body: ProductSortimentsPricingRequest
}

export function getProductSortimentsForPricing(http: HttpClient, rootUrl: string, params: GetProductSortimentsForPricing$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductSortimentsPricingResponse>>> {
  const rb = new RequestBuilder(rootUrl, getProductSortimentsForPricing.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProductSortimentsPricingResponse>>;
    })
  );
}

getProductSortimentsForPricing.PATH = '/pricing/selected';
